// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.alert {
  background-color: transparent;
  margin-bottom: 0;
}
.alert.alert-info {
  color: var(--primary);
  border-color: var(--primary);
}
.alert.alert-success {
  color: var(--success);
  border-color: var(--success);
}
.alert.alert-danger {
  color: var(--danger);
  border-color: var(--danger);
}
.alert.alert-warning {
  color: var(--warning);
  border-color: var(--warning);
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/alerta/alerta.component.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,SAAA;EACA,mBAAA;AACD;;AAEA;EACC,6BAAA;EACA,gBAAA;AACD;AAAC;EACC,qBAAA;EACA,4BAAA;AAEF;AAAC;EACC,qBAAA;EACA,4BAAA;AAEF;AAAC;EACC,oBAAA;EACA,2BAAA;AAEF;AAAC;EACC,qBAAA;EACA,4BAAA;AAEF","sourcesContent":["div {\n\tdisplay: flex;\n\tgap: 1rem;\n\talign-items: center;\n}\n\n.alert {\n\tbackground-color: transparent;\n\tmargin-bottom: 0;\n\t&.alert-info {\n\t\tcolor: var(--primary);\n\t\tborder-color: var(--primary);\n\t}\n\t&.alert-success {\n\t\tcolor: var(--success);\n\t\tborder-color: var(--success);\n\t}\n\t&.alert-danger {\n\t\tcolor: var(--danger);\n\t\tborder-color: var(--danger);\n\t}\n\t&.alert-warning {\n\t\tcolor: var(--warning);\n\t\tborder-color: var(--warning);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
